export const testimonials = [
  {
    id: 1,
    name: 'Jake Morrison',
    location: 'Oahu, Hawaii',
    role: 'Pro Surfer',
    rating: 5,
    text: 'Fixed a nasty reef crack and was back in the water the same session. PHIX Doctor is the real deal — cures faster than anything else I\'ve tried.',
    avatar: 'https://public.readdy.ai/ai/img_res/cf87f61656ff44d29beb7fca24bd1abe.jpg',
  },
  {
    id: 2,
    name: 'Sarah Chen',
    location: 'Gold Coast, Australia',
    role: 'Surf Instructor',
    rating: 5,
    text: 'Better than Solarez and it doesn\'t harden in the tube between uses. I recommend this to every student. The universal kit works on all our school boards.',
    avatar: 'https://readdy.ai/api/search-image?query=female%20surfer%20instructor%20portrait%20woman%20beach%20smiling%20athletic%20natural%20lighting%20ocean%20lifestyle%20photography%20close%20up&width=200&height=200&seq=avatar2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Marco Rivera',
    location: 'San Sebastián, Spain',
    role: 'Traveling Surfer',
    rating: 5,
    text: 'Saved my entire surf trip when my board got dinged in transit. The micro kit fits in my carry-on and cured in three minutes on the beach. Always in my bag now.',
    avatar: 'https://readdy.ai/api/search-image?query=young%20male%20surfer%20traveler%20portrait%20european%20man%20beach%20lifestyle%20photography%20warm%20natural%20outdoor%20lighting%20relaxed%20confident&width=200&height=200&seq=avatar3&orientation=squarish',
  },
  {
    id: 4,
    name: 'Tom Kealani',
    location: 'Byron Bay, Australia',
    role: 'Shaper & Glasser',
    rating: 5,
    text: 'As a professional shaper, I\'m picky about repair products. PHIX Doctor\'s bio-resin is genuinely impressive — clean cure, no yellowing, and that shelf life is unmatched.',
    avatar: 'https://readdy.ai/api/search-image?query=male%20surfboard%20shaper%20craftsman%20portrait%20workshop%20beach%20town%20lifestyle%20photography%20mature%20man%20confident%20skilled%20tradesperson&width=200&height=200&seq=avatar4&orientation=squarish',
  },
  {
    id: 5,
    name: 'Priya Nair',
    location: 'Bali, Indonesia',
    role: 'Surf Blogger',
    rating: 5,
    text: 'I\'ve tested a dozen repair kits for my blog. PHIX Doctor is hands-down the cleanest application and fastest cure. My readers love it too.',
    avatar: 'https://readdy.ai/api/search-image?query=female%20surf%20blogger%20portrait%20woman%20tropical%20beach%20bali%20lifestyle%20photography%20smiling%20confident%20content%20creator%20natural%20outdoor%20light&width=200&height=200&seq=avatar5&orientation=squarish',
  },
];
